import { createContext, useContext } from 'react'

/**
 * Per-slot context indicating whether the enclosing {@link PreferencesPageSlot}
 * is the currently visible Settings SubPage. Pages that need to gate global
 * side effects on visibility (document-level listeners, layout reads against
 * elements that read zero size when `display: none`) can subscribe via
 * {@link useIsActiveSettingsPage}.
 *
 * Mirrors `ActiveTabContext` from the TabStack — the same persistence
 * pattern (lazy mount + display:none hide) is used here, and pages face
 * the same hidden-subtree gotchas described in CLAUDE.md.
 */
const ActiveSettingsPageContext = createContext<boolean>(true)

export const ActiveSettingsPageProvider = ActiveSettingsPageContext.Provider

export function useIsActiveSettingsPage(): boolean {
  return useContext(ActiveSettingsPageContext)
}
